import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ManageEntitiesDialog from '@/views/agents/components/manage-dialog/manageEntitiesDialog.vue';
import BuildCacheClustersTable from '@/views/agents/components/buildcache-clusters/buildCacheClustersTable.vue';
import { useBuildCacheClustersProvider } from '@/views/agents/components/buildcache-clusters/buildCacheClusters.helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'manageClustersDialog',
  setup(__props) {

const { searchInputVal, sort, clustersList, addNewClusterRow } = useBuildCacheClustersProvider();
const handleSortChange = (newTableSort: { name: string; descending: boolean }) => {
  sort.value = newTableSort;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ManageEntitiesDialog, {
    "add-entity": _unref(addNewClusterRow),
    modelValue: _unref(searchInputVal),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(searchInputVal) ? (searchInputVal).value = $event : null)),
    "dialog-title": "Manage Build Cache Clusters",
    "dialog-name": "manageBuildCacheClustersDialog",
    "add-entity-button-title": 'Add Cluster'
  }, {
    "table-slot": _withCtx(({ isClosed }) => [
      _createVNode(BuildCacheClustersTable, {
        clusters: _unref(clustersList) || [],
        "is-closed": isClosed,
        onUpdateTableSort: handleSortChange
      }, null, 8, ["clusters", "is-closed"])
    ]),
    _: 1
  }, 8, ["add-entity", "modelValue"]))
}
}

})